<template>
	<div
		class="node-pricing"
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		:style="getWrapperStyle(node)"
		@click="onNodeClick(node)"
	>
		<!-- :style="getWrapperStyle(node)" -->
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div class="pricing-wrapper text-center" :style="getMainStyle(node)">
			<!-- header -->
			<div class="pricing-table-header" :style="getTitleWrapperStyle(node)">
				<div :style="getTitleStyle(node)" v-html="node.options.title" />
			</div>

			<div class="pricing-table-content">
				<!-- subtitle -->
				<div class="price-table-subtitle" :style="getSubTitleWrapperStyle(node)">
					<div :style="getSubTitleStyle(node)" v-html="node.options.subTitle" />
				</div>

				<!-- price -->
				<div class="pricing-table-price" :style="getPriceWrapperStyle(node)">
					<div class="price-strike" v-if="node.options.strikePrice && node.options.strikePrice !== ''">
						<span v-if="node.options.currency && node.options.currency !== ''">{{ node.options.currency }}</span> {{ node.options.strikePrice }}
					</div>
					<div class="d-flex justify-content-center align-items-baseline" :style="getPriceStyle(node)">
						<div class="price-currency mr-1" v-if="node.options.currency && node.options.currency !== ''">{{ node.options.currency }}</div>
						<div><b v-if="node.options.price && node.options.price !== ''">{{ node.options.price }}</b></div>
					</div>
					<div class="text-sm">{{ node.options.frequency }}</div>
				</div>

				<div class="pricing-table-feature">
					<!-- label -->
					<div :style="getFeatureLabelWrapperStyle(node)">
						<div v-if="node.options.featureLabel && node.options.featureLabel !== ''">
							<div :style="getFeatureLabelStyle(node)" v-html="node.options.featureLabel" />
						</div>
					</div>

					<!-- list -->
					<div>
						<ul>
							<li
								v-for="(feature, index) in node.options.features"
								:key="`feature-${index}`"
								:style="getFeatureStyle(node)"
							>
								<i
									v-if="feature.iconKey && feature.iconKey !== ''"
									:style="getIconStyle(feature)"
									:class="getIconClass(feature)"
									class="pricing-table-icon"
								></i> {{ feature.label }}
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="pricing-table-footer">
				<a class="btn btn-primary" :href="node.options.buttonLink" :style="getButtonStyle(node)" :target="node.options.buttonLinkNewTab ? '_blank' : '_self'" @click.stop.prevent>
					<!-- <b>{{ node.options.buttonText  }}</b> -->
					<div class="d-flex">
						<div class="mx-auto d-flex align-items-center">
							<template v-if="node.options.buttonIconKey && node.options.buttonIconKey !== '' && node.options.buttonIconPosition === 'before'">
								<i :style="getButtonIconStyle(node, 'before')" :class="getButtonIcon(node)"></i>
							</template>
							<div class="mx-auto">
								<b v-html="node.options.buttonText"></b>
							</div>
							<template v-if="node.options.buttonIconKey && node.options.buttonIconKey !== '' && node.options.buttonIconPosition === 'after'">
								<i :style="getButtonIconStyle(node, 'after')" :class="getButtonIcon(node)"></i>
							</template>
						</div>
					</div>
				</a>
			</div>
		</div>

	</div>
</template>

<script>
import { mapActions } from 'vuex';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';

import {
	// getIconStyle,
	getRgbaColor,
	getNodeStyle,
	getIcon,
} from '@/lib/helper';

// eslint-disable-next-line
const pricings = {
	items: [
		{
			name: 'Personal',
			price: '$300',
			subTitle: '',
			fontFamily: '',
			fontSize: '',
			fontWeight: '',
			fontSizeUnit: '',
			textColor: {
				rgb: {
					a: 1,
					b: 255,
					g: 255,
					r: 255,
				},
			},
			buttonBackgroundColor: '',
			buttonTextColor: '',
			features: [
				{
					label: 'Full Support : No',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',
				},
				{
					label: 'Duration : 30 Days',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',
				},
				{
					label: 'Admin Support',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',

				},
			],
			actionText: 'Buy Now',
			link: '',
			isRecomended: false,
		},
		{
			name: 'Business',
			price: '$300',
			subTitle: '',
			fontFamily: '',
			fontSize: '',
			fontWeight: '',
			fontSizeUnit: '',
			textColor: {
				rgb: {
					a: 1,
					b: 255,
					g: 255,
					r: 255,
				},
			},
			buttonBackgroundColor: '',
			buttonTextColor: '',
			features: [
				{
					label: 'Full Support : No',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',
				},
				{
					label: 'Duration : 30 Days',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',
				},
				{
					label: 'Admin Support',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',

				},
			],
			actionText: 'Buy Now',
			link: '',
			isRecomended: true,
		},
		{
			name: 'Profesional',
			price: '$300',
			subTitle: '',
			fontFamily: '',
			fontSize: '',
			fontWeight: '',
			fontSizeUnit: '',
			textColor: {
				rgb: {
					a: 1,
					b: 255,
					g: 255,
					r: 255,
				},
			},
			buttonBackgroundColor: '',
			buttonTextColor: '',
			features: [
				{
					label: 'Full Support : No',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',
				},
				{
					label: 'Duration : 30 Days',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',
				},
				{
					label: 'Admin Support',
					iconKey: 'check',
					iconStyle: 'solid',
					iconColor: '',
					iconSize: '',
					iconSizeUnit: 'px',
					mobileIconSize: 1,
					mobileIconSizeUnit: 'em',

				},
			],
			actionText: 'Buy Now',
			link: '',
			isRecomended: false,
		},

	],
};

export default {
	name: 'NodePricing',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
	},
	data() {
		return {
			isLoading: false,
		};
	},
	computed: {
		pricing() {
			return this.node?.options.items || [];
		},
	},
	methods: {
		...mapActions({
			setActionElement: 'funnels/setActionElement',
		}),
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'padding',
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getMainStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'box-shadow',
				'border',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getTitleWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'title-padding',
				'title-bg-color',
				'title-border',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getTitleStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'title-color',
				'title-font-size',
				'title-line-height',
				'title-font-family',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getSubTitleWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'subtitle-padding',
				'subtitle-bg-color',
				'subtitle-border',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getSubTitleStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'subtitle-color',
				'subtitle-font-size',
				'subtitle-line-height',
				'subtitle-font-family',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getPriceWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'price-padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getPriceStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'price-color',
				'price-font-size',
				'price-line-height',
				'price-font-family',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getFeatureLabelWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'feature-label-padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getFeatureLabelStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'feature-label-color',
				'feature-label-font-size',
				'feature-label-line-height',
				'feature-label-font-family',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getFeatureWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'feature-padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getFeatureStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'feature-color',
				'feature-font-size',
				'feature-line-height',
				'feature-font-family',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getButtonStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'button-padding',
				'button-font-size',
				'button-color',
				'button-bg-color',
				'button-line-height',
				'button-border',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getItemStyle({ options }) {
			const style = {};

			if (options) {
				const { spaceBetween } = options;
				style['padding-bottom'] = `calc(${spaceBetween}px/2)`;
			}
			return style;
		},

		getIcon(item) {
			return getIcon(item.iconKey, item.iconStyle);
		},

		getIconStyle(item) {
			const style = {};

			if (item) {
				const device = this.previewDevice;

				style.color = item.iconColor && item.iconColor.rgb && item.iconColor.rgb !== ''
					? getRgbaColor(item.iconColor.rgb)
					: item.iconColor;

				if (device === 'desktop') {
					const fixedIconSizeUnit = item.iconSizeUnit && item.iconSizeUnit !== '' ? item.iconSizeUnit : 'px';
					style['font-size'] = item.iconSize && item.iconSize !== ''
						? `${item.iconSize}${fixedIconSizeUnit}`
						: '12px';
				} else if (device === 'mobile') {
					const fixedMobileIconSizeUnit = item.mobileIconSizeUnit && item.mobileIconSizeUnit !== '' ? item.mobileIconSizeUnit : 'px';
					style['font-size'] = item.mobileIconSize && item.mobileIconSize !== ''
						? `${item.mobileIconSize}${fixedMobileIconSizeUnit}`
						: '12px';
				}

				if (item.iconSpacing && item.iconSpacing !== '') {
					style['margin-right'] = `${item.iconSpacing}px`;
				}
			}
			return style;
		},

		getIconClass(item) {
			return getIcon(item.iconKey, item.iconStyle);
		},

		getButtonIcon(node) {
			const iconStyle = node.options.buttonIconStyle;
			const iconKey = node.options.buttonIconKey;
			return getIcon(iconKey, iconStyle);
		},

		getButtonIconStyle(node, position) {
			let style = '';
			if (node && node.options && node.options.buttonIconSpacing && position === 'before') {
				style = `margin-right: ${node.options.buttonIconSpacing}px`;
			} else if (node && node.options && node.options.buttonIconSpacing && position === 'after') {
				style = `margin-left: ${node.options.buttonIconSpacing}px`;
			}
			return style;
		},

		onNodeClick(node) {
			this.handleAction('edit', node);
		},

		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
			// this.setActionElement({ type, node });
		},
	},
};
</script>

<style lang="scss">
.pricing-wrapper {
	display: flex;
	margin: 0 auto;
	flex-direction: column;
}

.featured {
	-webkit-transform: scale(1.1, 1.1);
	-moz-transform: scale(1.1, 1.1);
	-ms-transform: scale(1.1, 1.1);
	-o-transform: scale(1.1, 1.1);
	transform: scale(1.1, 1.1);
}

.pricing-table-header {
	// border-radius: 5px 5px 0px 0px;
	padding: 16px;
	text-align: center;
	border-top-left-radius: inherit;
	border-top-right-radius: inherit;

	h3 {
		color: #fff;
		font-size: 14px;
		text-transform: uppercase;
	}
}

.pricing-table-content {
	// background-color: #fff;

	ul {
		padding-left: 0;
		list-style: none;

		li {
			font-size: 14px;
			padding: .7rem;
			text-align: center;
		}
	}

	.pricing-table-price {
		.price-strike {
			font-size: 16px;
			color: red;
			text-decoration: line-through;
		}

		.price-currency {
			font-size: 14px;
		}

	}
}


.pricing-table-footer {
	// border-radius: 0px 0px 5px 5px;
	padding: 16px 0 30px 0;
	text-align: center;

	p {
		font-size: 12px;
		text-transform: uppercase;
	}


}

.pricing-table-icon {
	margin-right: 3px;
}


</style>
